import Icon from "../sharedComponents/icons/fontawsomeIcons";

const Titlebar = ({
  title,
  hasIcon,
  customImage,
  width,
  icon,
  imgWidth,
  imgHeight,
  containerHeight,
  containerWidth,
  hasSvg,
  widthOfBar,
  containerStyle,
}) => {
  return (
    <div
      className={`${width ?? "w-100"} ${containerStyle}`}
      style={{ width: widthOfBar }}
    >
      <div className="py-2 mx-3 d-flex" style={{ color: "#0C574C" }}>
        {hasIcon ? (
          icon ? (
            icon
          ) : (
            <Icon
              className="mx-1"
              name="file-alt"
              iconPrefix={"fas"}
              size={16}
            />
          )
        ) : customImage ? (
          <div
            style={{
              backgroundColor: "white",
              height: containerHeight ?? 36,
              width: containerWidth ?? 36,
              borderRadius: "50%",
            }}
            className="d-flex justify-content-center text-center align-items-center px-1"
          >
            <div
              style={{
                width: imgWidth ?? 18,
                height: imgHeight ?? 18,
                background: `url("${customImage}")`,
                opacity: 1,
                backgroundPosition: "center",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
              }}
            ></div>
          </div>
        ) : (
          <></>
        )}

        <div
          className="px-1 d-flex fw-bold align-items-center"
          style={{ color: "#0C574C" }}
        >
          {title}
        </div>
      </div>
      <hr className="m-0" style={{ width: widthOfBar }} />
    </div>
  );
};

export default Titlebar;
